import { render, staticRenderFns } from "./IconsSelector.vue?vue&type=template&id=57859ce4&scoped=true"
import script from "./IconsSelector.vue?vue&type=script&lang=ts"
export * from "./IconsSelector.vue?vue&type=script&lang=ts"
import style0 from "./IconsSelector.vue?vue&type=style&index=0&id=57859ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57859ce4",
  null
  
)

export default component.exports